<template>
  <v-dialog persistent v-model="dialog" max-width="800px">
    <v-btn
      icon
      slot="activator"
    >
      <v-icon color="primary">edit</v-icon>
    </v-btn>
    <v-card>
      <v-card-title class="primary">
        <span class="headline white--text">Gästeliste bearbeiten</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  label="Titel"
                  v-model="localGroup.title"
                  :disabled="loading"></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
        <small>*Pflichtfelder</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click.native="dialog = false">Abbrechen</v-btn>
        <v-btn color="primary" @click.native="update()" :loading="loading">Speichern</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {mapActions} from 'vuex';

  export default {
    name: 'DlgGroupUpdate',
    props: ['group'],
    data() {
      return {
        dialog: false,
        localGroup: {},
        loading: false,
        valid: true,
        genders: [
          {
            text: 'Weiblich',
            value: 'female',
          },
          {
            text: 'Männlich',
            value: 'male',
          },
        ],
      };
    },
    methods: {
      ...mapActions({
        updateGroup: 'admin/groups/update',
        readGroups: 'admin/groups/read',
      }),
      update() {
        if (this.$refs.form.validate()) {
          this.loading = true;
          this.updateGroup(this.localGroup).then((success) => {
            this.loading = false;
            if (success) {
              this.readGroups();
              this.localGroup = {};
              this.dialog = false;
            }
          });
        }
      },
    },
    watch: {
      dialog() {
        this.localGroup = JSON.parse(JSON.stringify(this.group));
      },
    },
  };
</script>

<style scoped>

</style>
